import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  todos: [],
  isLogin: false,
  userData: null,
  isPermission: false,
};
const AuthReducer = createSlice({
  name: "userData",
  initialState,
  reducers: {
    setPositionsAction(state, action) {
      state.userData = action.payload;
    },
    loginUserData(state, action) {
      global.userData = action.payload;
      state.userData = action.payload;
      state.isLogin = true;
    },
    logOut(state) {
      state.isLogin = false;
      state.isPermission = false;
      state.userData = null;
      localStorage.removeItem("@userData");
    },
    permission(state) {
      state.isPermission = true;
    },
  },
});

export const { setPositionsAction, loginUserData, logOut, permission } =
  AuthReducer.actions;

export default AuthReducer.reducer;
